import { SET_HOME_PAGE_DATA_MUTATION } from "@/store/storeconstants";

export default {
    [SET_HOME_PAGE_DATA_MUTATION](state, payload) {
        state.home = payload
    },
    
};